/**
 * Score history — cross-page, browser-local timeline of readiness scores.
 *
 * Every meaningful score update (checklist +1, workbook toolbox 0/5/10)
 * appends a point, capped to one entry per (kind, day) so the chart stays
 * clean and the payload stays small. Everything lives in encrypted
 * secureStorage — no server round-trip.
 */
import { secureGetJSON, secureSet } from "./secureStorage";

const KEY = "centennial_score_history_v1";
const MAX = 400; // ~13 months of daily entries across both kinds

const todayIso = () => new Date().toISOString().slice(0, 10);

export function loadHistory() {
  return secureGetJSON(KEY, []);
}

export function saveHistory(list) {
  secureSet(KEY, list.slice(-MAX));
}

/**
 * Append a score point.
 * @param {"checklist"|"workbook"} kind
 * @param {number} score        raw score
 * @param {number} total        total possible (50 or 100)
 */
export function appendScore(kind, score, total) {
  const list = loadHistory();
  const day = todayIso();
  const last = list.length ? list[list.length - 1] : null;
  // If the same kind was updated today, replace that entry (latest wins).
  if (last && last.kind === kind && last.day === day) {
    if (last.score === score) return list; // no change → no write
    const next = [...list.slice(0, -1), { day, kind, score, total, ts: Date.now() }];
    saveHistory(next);
    return next;
  }
  const next = [...list, { day, kind, score, total, ts: Date.now() }];
  saveHistory(next);
  return next;
}
